import apiClient from '../client'

export interface MenuItemAdminResponse {
  id: string
  tenantId: string | null
  parentId: string | null
  code: string
  label: string
  route: string | null
  icon: string | null
  order: number
  isGroup: boolean
  isHidden: boolean
  isComingSoon: boolean
  isSystem: boolean
  requiredPermissionCode: string | null
  hasOverlay: boolean
  isOverlay: boolean
}

export interface CreateMenuItemRequest {
  parentId: string | null
  code: string
  label: string
  route: string | null
  icon: string | null
  order: number
  isGroup: boolean
  isComingSoon: boolean
  requiredPermissionCode: string | null
  tenantId: string | null
}

export interface UpdateMenuItemRequest {
  parentId: string | null
  label: string
  route: string | null
  icon: string | null
  order: number
  isGroup: boolean
  isHidden: boolean
  isComingSoon: boolean
  requiredPermissionCode: string | null
}

export const menusService = {
  async list(): Promise<MenuItemAdminResponse[]> {
    return apiClient.get<MenuItemAdminResponse[]>('/menus')
  },

  async create(body: CreateMenuItemRequest): Promise<MenuItemAdminResponse> {
    return apiClient.post<MenuItemAdminResponse, CreateMenuItemRequest>('/menus', body)
  },

  async update(id: string, body: UpdateMenuItemRequest): Promise<MenuItemAdminResponse> {
    return apiClient.put<MenuItemAdminResponse, UpdateMenuItemRequest>(`/menus/${id}`, body)
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete<boolean>(`/menus/${id}`)
  },

  async override(globalMenuItemId: string): Promise<MenuItemAdminResponse> {
    return apiClient.post<MenuItemAdminResponse, undefined>(
      `/menus/override/${globalMenuItemId}`,
      undefined,
    )
  },
}
